module.exports = __webpack_public_path__ + "img/personal-details.89b0c29e.svg";